export const snippetsStyles = () => ({
    header: {
        display: 'flex',
        alignItems: 'center'
    },
    practitionersCell: {
        maxWidth: 400,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    snippetCard: {
        backgroundColor: '#fff',
        borderRadius: 4,
        boxShadow:
            '0px 1px 3px 0px rgba(0,0,0,0.12), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.2)',
        padding: '24px 16px 16px',
        marginBottom: 8
    },
    snippetModal: {
        '& .MuiDialog-paper': {
            maxHeight: '90vh'
        },
        '& .MuiDialogContent-root': {
            overflowY: 'auto'
        },
        '& .MuiAutocomplete-inputRoot': {
            height: 'auto !important',
            minHeight: 38
        }
    }
});
